import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getSingle, updateSingle } from "../../services/privateAccountService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import TableTitle from "../common/tableTitle";
import { Table } from "semantic-ui-react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import queryString from "query-string";

class PrivateAccountEditForm extends Form {
  state = {
    show_in_ledger_when_close_options: [
      { id: "", name: "Select option" },
      { id: 1, name: "Yes" },
      { id: 0, name: "No" },
    ],
    data: {
      passport_number: "",
      identification_id: "",
      mobile: "",
      name: "",
      email_address: "",
      show_in_ledger_when_close: "",
    },
    account_type: "",
    errors: {},
  };

  schema = {
    passport_number: Joi.string().required().label("Passport"),
    identification_id: Joi.string().allow("").label("Emirates ID"),
    mobile: Joi.string().required().label("Mobile"),
    name: Joi.string().required().label("Name"),
    email_address: Joi.string().allow("").label("Email Address"),
    show_in_ledger_when_close: Joi.string()
      .allow("")
      .label("show in ledger when close option"),
  };

  async populateAccount() {
    try {
      const accountId = this.props.match.params.id;
      this.setState({ blocking: true });
      const { data: account } = await getSingle(accountId);

      this.setState({ blocking: false });
      this.setState({
        account_type: account.account_type,
        data: this.mapToViewModel(account),
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    await this.populateAccount();
    document.getElementById("account_type").value = this.state.account_type;
  }

  mapToViewModel(account) {
    return {
      passport_number: account.passport_number,
      identification_id: account.identification_id,
      mobile: account.mobile,
      name: account.name,
      email_address: account.email_address,
      show_in_ledger_when_close: account.show_in_ledger_when_close,
    };
  }

  doSubmit = async () => {
    try {
      const ledgerTypeId = this.props.match.params.id;

      const data = { ...this.state.data };
      data.id = parseInt(ledgerTypeId);
      data.account_type = document.getElementById("account_type").value;
      this.setState({ blocking: true });
      await updateSingle(data);
      this.setState({ blocking: false });
      toast.success("Account has been updated successfully.");
      this.props.history.push("/private-accounts");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.passport_number)
          errors.passport_number = ex.response.data.errors.passport_number;

        if (ex.response.data.errors.identification_id)
          errors.identification_id = ex.response.data.errors.identification_id;

        if (ex.response.data.errors.mobile)
          errors.mobile = ex.response.data.errors.mobile;

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  render() {
    const { keyword, status } = queryString.parse(this.props.location.search);

    // if (auth.getCurrentUser().role != "company") {
    //   return "Your are authorized to perform this action.";
    // }
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Update account</h1>
        <Link
          to={`/private-accounts?keyword=${keyword}&status=${status}`}
          className="btn btn--secondary"
          style={{ marginBottom: "1rem", display: "inline-block" }}
        >
          Back
        </Link>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Update account</h3>
              <p>Provide the information below to add the account.</p>
              {this.renderInput("passport_number", "Company Name", "text")}
              {this.renderInput("identification_id", "Emirates ID", "text")}
              {this.renderInput("mobile", "Mobile", "text")}
              {this.renderInput("name", "Name", "text")}
              {this.renderInput("email_address", "Email Address", "text")}

              <label>Account Type</label>
              <select name="account_type" id="account_type" className="input">
                <option value="">Select type</option>
                <option value="jv">JV</option>
                <option value="scrap">SCRAP</option>
              </select>
              <br />
              <br />

              {this.renderSelect(
                "show_in_ledger_when_close",
                "Show in ledger when close",
                this.state.show_in_ledger_when_close_options
              )}

              {this.renderButton("Update")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default PrivateAccountEditForm;
